import http from "./http";

export default {
  // O parâmetro é `q`, e isso não é detalhe: `teams#search` faz
  // `params[:q]&.downcase || ""` e cai num `LIKE '%%'` quando o campo não vem.
  // Mandar `name=` não dá erro — devolve a lista inteira (limitada a 50), o que
  // parece busca funcionando e não é.
  search(q) {
    return http.plainAxiosInstance.get(`/teams/search`, { params: { q } });
  }
};
